import { ref, uploadBytesResumable, UploadTask } from "firebase/storage";
import { CuratedOrganization, CuratedTeacher, Faculty, HiredTeacherPlacements } from "models";
import { edDeptInfoSlide } from "models/EdDeptInfoSlide";
import { storage } from "services";

/**
 * Uploads a profile photo for an alum.
 * @param file The file to be uploaded.
 * @param alum The alum to which the profile photo is assigned.
 * @returns An UploadTask that allows you to monitor and manage the upload.
 */
export function uploadProfilePhoto(
  file: File,
  photo: CuratedTeacher | CuratedOrganization | Faculty | HiredTeacherPlacements,
): UploadTask {
  const photoRef = ref(storage, `profilePhotos/${photo.id || file.name}`);
  return uploadBytesResumable(photoRef, file);
}

export function uploadInfoSlide(file: File, slide: edDeptInfoSlide): UploadTask {
  const slideRef = ref(storage, `edDeptInfoSlide/${slide.id || file.name}`);
  return uploadBytesResumable(slideRef, file);
}

// export async function getSlideInfo(): Promise<string[]> {
//   const snapshot = await db.collection(dbCollections.edDeptInfoSlide).get();
//   return snapshot.docs.map(doc => {
//     return { ...doc.data(), id: doc.id } as string;
//   });
// }

// export async function getAllSlide(): Promise<string[]> {
//   // storageRef
//   //       .child("edDeptInfoSlide/")
//   //       .listAll()
//   //       .then(function (result) {
//   //         result.items.forEach(function (imageRef) {
//   //           imageRef
//   //             .getDownloadURL()
//   //             .then(function (url) {
//   //               setPhotos([]);
//   //               photos.push(url);
//   //               setPhotos(photos);
//   //             })
//   //             .catch(function (error) {
//   //               alert("Something went here! please try again");
//   //             });
//   //         });
//   //       })
//   //       .catch(function (error) {
//   //         console.log(error);
//   //       });
//   const snapshot = await storageRef.child("edDeptInfoSlide/").listAll();
//   return snapshot.
// }
